enum AgeType {
  'Adult',
  'Child'
}

export default AgeType;
